import _ from 'lodash'
import moment from 'moment'
import TimeUtils from '../../../utils/TimeUtils'
import { toast } from 'react-toastify'

toast.configure()

export default function validate(getValidationSchema) {
    return values => {
        const validationSchema = getValidationSchema(values)
        try {
            // if (_.isArray(values.actionType)) values.actionType = {}
            validationSchema.validateSync(values)
            // logic check
            // const start = TimeUtils.combineDateNTime(
            //     _.head(values.range).toDate(),
            //     values.startTime
            // )
            // const end = TimeUtils.combineDateNTime(
            //     _.last(values.range).toDate(),
            //     values.endTime
            // )

            // if(values.actionType.value >= 99){
            //     if (moment(end).isSameOrBefore(start)) {
            //                                                return {
            //                                                    error:
            //                                                        'Start time is equal to end time',
            //                                                }
            //                                            }
    
            //     if (moment(end).diff(start, 'minutes') < 30) {
            //         return { error: 'Invalid start and end time' }
            //     }
    
            // } else {
            //            if (values.hours <= 0 && moment(start).isSame(end, 'day')) {
            //                return { hours: 'hours is required' }
            //            }
            //        }

            // return {}
        } catch (e) {
            return e
        }
    }
}

function getErrorsFromValidationError(validationError) {
    return {}
}

// function getErrorsFromValidationError(validationError) {
//     const FIRST_ERROR = 0
//     return validationError.inner.reduce((errors, error) => {
//         let path = ''
//         let message = ''
//         if (_.includes(error.path, 'actionType')) {
//             path = _.head(_.split(error.path, '.'))
//         } else if(_.includes(error.path, 'hours') || _.includes(error.path, 'break')) {
//             path = error.path
//             message = "must be a number type"
//             error.errors[FIRST_ERROR] = message
//         } else {
//             path = error.path
//         }
//         return {
//             ...errors,
//             [path]: error.errors[FIRST_ERROR],
//         }
//     }, {})
// }
